import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminTermsHeader = ({
  termsVisible,
  termsTotal,
  loading,
  handleAddTerm,
  handleImportTerms,
  taxonomy,
}) => {
  const intl = useIntl();

  return (
    <header id="terms-list-header" className="page-header">
      <h3 className="page-title">
        {intl.formatMessage({ defaultMessage: 'Tags' })}
      </h3>
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {(!loading) && (
            <span>
              {intl.formatMessage(
                { defaultMessage: '{termsVisible} of {termsTotal} tags' },
                { termsVisible, termsTotal },
              )}
            </span>
          )}
        </div>
        {!taxonomy.ai_tagging && (
          <div className="button-wrapper">
            <Button color="primary" onClick={handleAddTerm}>
              <i className="fas fa-plus" />
              {intl.formatMessage({ defaultMessage: 'Tag' })}
            </Button>
            {' '}
            <Button color="primary" onClick={handleImportTerms}>
              <i className="fas fa-cloud-arrow-up" />
              {intl.formatMessage({ defaultMessage: 'Import tags' })}
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

AdminTermsHeader.propTypes = {
  taxonomy: PropTypes.object.isRequired,
  termsVisible: PropTypes.string.isRequired,
  termsTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  handleAddTerm: PropTypes.func.isRequired,
  handleImportTerms: PropTypes.func.isRequired,
};

export default AdminTermsHeader;
